import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import VueGoogleMaps from '@fawmi/vue-google-maps';
import i18n from './i18n'

const app = createApp(App);
app.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_MAPS_API_KEY,
  },
})
app.use(i18n);
app.mount('#app');
